import React, { useEffect, useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { Button, Col, Form, Row, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { typehome } from 'config'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import fr from 'date-fns/locale/fr';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { useFormatDate } from 'hooks';
import IconButton from 'components/common/IconButton';
import moment from 'moment';
import { API_URL } from 'constants';
import { toastr } from 'react-redux-toastr';

const Search = () => {

    registerLocale('fr', fr);
    setDefaultLocale('fr');
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({});
    const [l, setL] = React.useState(false);
    const [checkIn, setCheckIn] = React.useState(null);
    const [checkOut, setCheckOut] = React.useState(null);
    const [valueType, setValueType] = React.useState(null);
    const [properties, setProperties] = React.useState([]);
    const [bookings, setBookings] = React.useState([]);
    const [data, setData] = React.useState([])
    const [typehomem, setTypH] = React.useState([])
    const [searchs, setSearchs] = React.useState([]);
    const [users, setUsers] = React.useState([]);
    const [isadmin, setAdmin] = React.useState(false)
    const [propertiesCheck, setPropertiesCheck] = React.useState([]) 
    const getUserL = async (uid, s, cb) => {
        let d = null;
        s.forEach(u => {
            if (u.value === uid) {
                d = u.data
                d.id = u.value
            }
        })
        cb(d)
    };


    const getSearchs = () => {
        firebase.firestore().collection('searchs')
            .orderBy('_create_At', 'desc')
            .get().then((ls) => {
                let s = [];
                ls.forEach((d) => {
                    let e = d.data()
                    e.id = d.id;
                    if (e?.delete === true) {

                    } else {
                        s.push(e)
                    }
                })
                // console.log("search", s);
                setSearchs(s);

            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
            })

    }

    const navigate = useNavigate();

    function levenshteinDistance(str1, str2) {
        const len1 = str1.length;
        const len2 = str2.length;

        const matrix = [];

        // Initialize the distance matrix
        for (let i = 0; i <= len1; i++) {
            matrix[i] = [i];
        }
        for (let j = 0; j <= len2; j++) {
            matrix[0][j] = j;
        }

        // Calculate the distances
        for (let j = 1; j <= len2; j++) {
            for (let i = 1; i <= len1; i++) {
                if (str1.charAt(i - 1) === str2.charAt(j - 1)) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = Math.min(
                        matrix[i - 1][j - 1] + 1,  // substitution
                        matrix[i][j - 1] + 1,      // insertion
                        matrix[i - 1][j] + 1       // deletion
                    );
                }
            }
        }

        // Return the Levenshtein distance
        return matrix[len1][len2];
    }

    function textsAreSimilar(text1, text2, threshold) {
        const distance = levenshteinDistance(text1, text2);
        const maxLength = Math.max(text1.length, text2.length);
        const similarityPercentage = ((maxLength - distance) / maxLength) * 100;

        return similarityPercentage >= threshold;
    }

    function filtrerProprietesDisponibles(proprietes, dateDebut, dateFin, formu) {

        // console.log('filtrerProprietesDisponibles')
        // console.log("formu", formu)
        return proprietes.filter(propriete => {
            // Vérifiez si la propriété est disponible 
            const pId = propriete.id;

            // // Vérifiez si la propriété est réservée pendant la période spécifiée
            // for (let reservation of propriete.reservations) {
            if (dateDebut && dateFin) {
                bookings?.forEach(reservation => {
                    if (pId === reservation?.property?.value && reservation?.statut?.value === 'confirmed') {
                        if (reservation?.checkin?.toDate() <= dateFin && reservation?.checkout?.toDate() >= dateDebut) {
                            return false; // La propriété est réservée pendant la période
                        }
                    }
                })
            }

            if (formu?.type?.value) {
                if (propriete?.type?.value !== formu?.type?.value) {
                    return false;
                }
            }
            if ((formu?.kidsNbr || formu?.adultNbr) && propriete?.maxGuest) {
                let tt = Number(formu?.adultNbr || 0) + Number(formu?.kidsNbr || 0)
                if (Number(propriete?.maxGuest) < Number(tt)) {
                    return false
                }
            }
            if (formu?.roomsNbr) {//min 
                if (Number(propriete?.nbRooms) < Number(formu?.roomsNbr)) {
                    return false;
                }
            }

            if (formu?.roomsNbrMax) {//max 
                if (Number(propriete?.nbRooms) > Number(formu?.roomsNbrMax)) {
                    return false;
                }
            }

            if (formu?.priceMin) {
                let re = true;
                // if (Number(formu?.priceMin))
                let currentMonth = moment().month() + 1;
                if (dateDebut) {
                    currentMonth = moment(dateDebut).month() + 1;
                }
                propriete?.prices?.forEach((p) => {
                    let price = parseFloat(p?.price.replace(".", ""))
                    let currentMonthData = p?.months.find(month => month?.value === currentMonth);
                    if (currentMonthData) {
                        // Si le mois actuel est trouvé dans la liste des mois
                        // console.log("Le prix pour le mois en cours est : " + Number(price), Number(formu?.priceMin));
                        if (Number(price) < Number(formu?.priceMin)) {
                            // console.log("Le prix minimum est plus grand")
                            re = false
                        } else {
                            // console.log("Le prix minimum est plus petit")
                        }
                    } else {
                        // Si le mois actuel n'est pas trouvé dans la liste des mois
                        // console.log("Il n'y a pas de prix disponible pour le mois en cours.");
                    }
                })

                if (!re) {
                    return false
                }
                // console.log("ici", propriete.prices)
            }

            if (formu?.priceMax) {
                let re = true;
                // if (Number(formu?.priceMin))
                let currentMonth = moment().month() + 1;
                if (dateDebut) {
                    currentMonth = moment(dateDebut).month() + 1;
                }
                propriete?.prices?.forEach((p) => {
                    // console.log("price", p.price,  p.months, currentMonth);
                    let price = parseFloat(p.price.replace(".", ""))
                    // console.log("price", price)
                    let currentMonthData = p?.months?.find(month => month?.value === currentMonth);
                    if (currentMonthData) {
                        // Si le mois actuel est trouvé dans la liste des mois
                        // console.log("Le prix pour le mois en cours est : " + Number(price), Number(formu?.priceMax));
                        if (Number(price) <= Number(formu?.priceMax)) {
                            // console.log("Le prix maximum est plus grand") 
                        } else {
                            // console.log("Le prix maximum est plus petit")
                            re = false
                        }
                    } else {
                        // Si le mois actuel n'est pas trouvé dans la liste des mois
                        // console.log("Il n'y a pas de prix disponible pour le mois en cours.");
                    }
                })
                if (!re) {
                    return false
                }
                // console.log("ici", propriete.prices)
            }
            // }



            if (formu?.destinate?.length > 0) {
                const threshold = 80;
                let b = false;
                if (textsAreSimilar(formu?.destinate, propriete?.nameHouse, threshold)) {
                    b = true;
                }
                if (textsAreSimilar(formu?.destinate, propriete?.zipcode, threshold)) {
                    b = true;
                }
                if (textsAreSimilar(formu?.destinate, propriete?.quartier, threshold)) {
                    b = true;
                }
                if (textsAreSimilar(formu?.destinate, propriete?.city, threshold)) {
                    b = true;
                }
                if (!b) {
                    return false;
                }
            }
            // La propriété est disponible pendant la période
            return true;
        });
    }

    const getDisponibilite = async (data, checkin, checkout, cb) => {
        console.log("getDisponibilite", data, checkin, checkout);
        cb({
            success: true,
            data: [],

        }) 
    }
    const filterVillas = (formData, properties, unavailabilities) => {




        return properties.filter((property) => {
            // 1. Filtrer par destination (destinate)
            if (formData.destinate) {
                // Diviser les critères de destination par les virgules et les nettoyer
                const destinations = formData.destinate.split(',').map((dest) => dest.trim());
                
                const fieldsToCompare = [
                    property.city || "",
                    property.zipcode || "",
                    property.nameHouse || "", // Si le nom de la maison doit être considéré
                    property.quartier || "", // Ajouter d'autres champs si nécessaire
                ];
    
                // Vérifier si au moins un critère correspond
                const hasMatchingDestination = destinations?.some((destination) => {
                    return fieldsToCompare?.some((field) => {
                        return getSimilarity(destination, field) >= 80;
                    });
                });
    
                if (!hasMatchingDestination) {
                    return false;
                }
            }
    
            // 2. Vérifier la plage de disponibilité
            if (
                formData.checkin &&
                formData.checkout &&
                isUnavailable(property.id, formData.checkin, formData.checkout, unavailabilities)
            ) {
                return false;
            }
            
            // console.log('searc', formData.checkin, formData.checkout);
            // 3. Vérifier le nombre d'invités (adultNbr + kidsNbr)
            const totalGuests = parseInt(formData.adultNbr || 0, 10) + parseInt(formData.kidsNbr || 0, 10);
            if (totalGuests > parseInt(property.maxGuest || 0, 10)) {
                return false;
            }
    
            // 4. Vérifier les chambres
            if (
                formData.roomsNbr &&
                parseInt(formData.roomsNbr, 10) > parseInt(property.nbRooms, 10)
            ) {
                return false;
            }
    
            if (
                formData.roomsNbrMax &&
                parseInt(formData.roomsNbrMax, 10) < parseInt(property.nbRooms, 10)
            ) {
                return false;
            }
    
            // 5. Vérifier le type de propriété
            if (formData.type?.value && formData.type.value !== property.type?.value) {
                return false;
            }
    
            // 6. Vérifier la plage de prix
            if (formData.priceMin || formData.priceMax) {
                const month = new Date(formData.checkin).getMonth() + 1; // Obtenir le mois (1-12)
                const isPriceValid = isWithinPriceRange(property, formData.priceMin, formData.priceMax, month);
                if (!isPriceValid) {
                    return false;
                }
            }
    
            // Si toutes les conditions sont respectées
            return true;
        });
    };

    const isUnavailable = (villaId, checkin, checkout, unavailabilities) => {
        const checkinDate = new Date(checkin);
        const checkoutDate = new Date(checkout);
    
        let mp = unavailabilities?.some((unavailability) => {
            if (unavailability.villaId !== villaId) return false;
    
            const unavailabilityStart = new Date(unavailability.startDate); 
            const updatedDate  = new Date(unavailability.endDate);  
            const unavailabilityEnd = new Date(updatedDate.getTime() - 12 * 60 * 60 * 1000); 
            
            return (
                (checkinDate >= unavailabilityStart && checkinDate <= unavailabilityEnd) ||
                (checkoutDate >= unavailabilityStart && checkoutDate <= unavailabilityEnd) ||
                (checkinDate <= unavailabilityStart && checkoutDate >= unavailabilityEnd)
            );
        }); 
       return mp;
    };

    const isWithinPriceRange = (property, priceMin, priceMax, month) => {
        return (property?.prices || [])?.some((priceInfo) => { 
            const isValidMonth = priceInfo.months?.some((m) => m.value === month);
 
            if (!isValidMonth) return false;
    
            const price = parseFloat(priceInfo.price || 0);
            const minPrice = parseFloat(priceMin || 0);
            const maxPrice = parseFloat(priceMax || Infinity); 
            return price >= minPrice && price <= maxPrice;
        });
    };
    const getSimilarity = (str1, str2) => {
        if (!str1 || !str2) return 0;
    
        const editDistance = (a, b) => {
            const matrix = [];
            for (let i = 0; i <= b.length; i++) {
                matrix[i] = [i];
            }
            for (let j = 0; j <= a.length; j++) {
                matrix[0][j] = j;
            }
            for (let i = 1; i <= b.length; i++) {
                for (let j = 1; j <= a.length; j++) {
                    if (b[i - 1] === a[j - 1]) {
                        matrix[i][j] = matrix[i - 1][j - 1];
                    } else {
                        matrix[i][j] = Math.min(
                            matrix[i - 1][j - 1] + 1, // Substitution
                            Math.min(
                                matrix[i][j - 1] + 1, // Insertion
                                matrix[i - 1][j] + 1 // Suppression
                            )
                        );
                    }
                }
            }
            return matrix[b.length][a.length];
        };
    
        const maxLength = Math.max(str1.length, str2.length);
        const distance = editDistance(str1.toLowerCase(), str2.toLowerCase());
    
        return (1 - distance / maxLength) * 100; // Retourne un pourcentage de similarité
    };
    const convertReservationsToUnavailabilities = (reservations) => {  
    
        return reservations
            .filter((res) => res.statut.value === "confirmed") // Prendre uniquement les réservations confirmées
            .map((res) => ({
                startDate: res.checkin?.seconds ? res.checkin?.toDate().toISOString().split("T")[0] : new Date(),
                endDate: res.checkout?.seconds ? res.checkout?.toDate().toISOString().split("T")[0] : new Date(),
                villaId: res.property.value,
            }));
    };
    const combineUnavailabilities = (existingUnavailabilities, reservationUnavailabilities) => {
        return [...existingUnavailabilities, ...reservationUnavailabilities];
    };

    const searc = (p, indisponibilites) => {
        // let proper = p;
        if (bookings.length > 0 ){
            // console.log("bookings", bookings[0])
            const additionalUnavailabilities = convertReservationsToUnavailabilities(bookings);
            const allUnavailabilities = combineUnavailabilities(indisponibilites, additionalUnavailabilities); 
            const fpd = filterVillas(formd, p, allUnavailabilities);
            setData(fpd) 
            setL(false)
        }else{
            firebase.firestore().collection('bookings').get().then((snap) => {
                let s = [];
                snap.forEach((d) => {
                    const dr = d.data()
                    dr.id = d.id;
                    if (dr?.delete) {
    
                    } else {
                        s.push(dr)
                    }
    
                })
                setBookings(s); 
                const additionalUnavailabilities = convertReservationsToUnavailabilities(s); 
                const allUnavailabilities = combineUnavailabilities(indisponibilites, additionalUnavailabilities);
                const fpd = filterVillas(formd, p, allUnavailabilities);
                setData(fpd)
            }).finally(() => { 
                setL(false)
            })
        } 

    }
    const [unavailabledates, setUnavailableDates] = useState([]);

    const loadList = (cb) => {
        firebase.firestore().collection('dates').doc('unavailable').get().then((doc) => {
              if (doc) {
                let d = doc.data();
                let dates = []
                if (d.dates) {
                    dates = d.dates
                  setUnavailableDates(d.dates);
                }
                firebase.firestore().collection('properties').get().then((snap) => {
                    let s = [];
                    snap.forEach((d) => {
                        const dr = d.data()
                        dr.id = d.id;
                        if (dr?.delete) {
        
                        } else {
                            s.push(dr)
                        }
                    })
                    setProperties(s);
                    cb(s, dates);
                }).catch((error) => {
                    setL(false);
                    var errorMessage = error.message;
                    toast.error(errorMessage);
                })
              }
            });
        // get list clients and format
        

        firebase.firestore().collection('bookings').get().then((snap) => {
            let s = [];
            snap.forEach((d) => {
                const dr = d.data()
                dr.id = d.id;
                if (dr?.delete) {

                } else {
                    s.push(dr)
                }

            })
            setBookings(s);
        }).catch((error) => {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        })

    }

    useEffect(() => {
        setL(true)
        getSearchs()
        getAllUser()

        let m = [{ label: 'Tout', value: null }];
        typehome.forEach(s => {
            m.push(s)
        })
        setTypH(m)
        loadList((n, indisponibilites) => {
            setL(false)
        })
    }, [])


    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false) {
            return;
        } 
        setL(true) 
        toast.warning("Recherche en cours, patientez...")
        if ((properties || [])?.length > 0) {
            loadList((p, indisponibilites) => {
                searc(p, indisponibilites)
            });
        } else {
            searc(properties, unavailabledates)
        }
    };


    const handleChange = e => {
        let d = { ...formd };
        // console.log(e.target, e.target.checked);  
        d[e.target.name] = e.target.value;
        if (e.target.name === "type") {
            d[e.target.name] = e.target.checked ? "partenaire" : "admin";
        }
        setFrom(d);
    };

    const save = () => {
        let search = { ...formd };
        let s = {
            search: JSON.stringify(search),
            result: JSON.stringify(data),
            _create_At: new Date(),
            uid: firebase.auth().currentUser.uid
        }
        setL(true);
        firebase.firestore().collection('searchs').add(s).then(() => {
            getSearchs()
            setL(false);
            toast.success('Recherche sauvegarder');
        }).catch(err => {
            setL(false);
            toast.error('Recherche non sauvegarder, une erreur s\'est produite');
        })


    }

    function generateString() {
        // Générer une chaîne aléatoire pour les trois premiers caractères (X)
        const randomDigits = Array.from({ length: 3 }, () => Math.floor(Math.random() * 10)).join('');

        // Obtenir la date actuelle
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Les mois sont 0-indexés
        const year = String(currentDate.getFullYear());

        // Créer la chaîne finale en utilisant le format requis
        const dateString = `${day}${month}${year}`;

        // Concaténer les parties pour former la chaîne finale
        const finalString = `${randomDigits}_${dateString}`;

        return finalString;
    }

    // Fonction pour trier par prix et mois
const sortByMonthAndPrice = (data, date) => {  
    // const monthLabel = getMonthLabel(date); // Mois en français (par ex. "juillet")
    const monthValue = date instanceof Date ? date?.getMonth() + 1 :  new Date().getMonth() + 1; // Mois numérique (par ex. 7 pour juillet)

    return data.sort((a, b) => {
        // Trouver les prix pour le mois dans chaque objet 
        if (a.prices === undefined ){
            toastr.error("Erreur de prix pour la villa "+ a.nameHouse)
        }
        const priceA = (a.prices === undefined ? [] : a.prices).find((p) =>
            p.months?.some((m) => m.value === monthValue)
        )?.price;  

        if (b.prices === undefined ){
            toastr.error("Erreur de prix pour la villa "+ b.nameHouse)
        }
        const priceB = (b.prices === undefined ? [] : b.prices).find((p) =>
            p.months?.some((m) => m.value === monthValue)
        )?.price;

        // Si un des objets n'a pas de prix pour le mois, placez-le à la fin
        if (!priceA && priceB) return 1;
        if (priceA && !priceB) return -1;

        // Si les deux ont un prix, comparez-les numériquement
        if (priceA && priceB) {
            return parseFloat(priceA) - parseFloat(priceB);
        }

        // Les deux n'ont pas de prix, conservez l'ordre actuel
        return 0;
    });
};

    const demand = () => {
        var t = { ...formd }
        t.checkin = formd?.checkin === undefined ? null : formd?.checkin;
        t.checkout = formd?.checkout === undefined ? null : formd?.checkout;
        t.uid = firebase.auth().currentUser.uid;
        t.bySearch = true;
        t._create_At = new Date();
        t._update_At = new Date();
        t.demand_date = new Date();
        t.statut = { value: 'created', label: 'En cours' };
        t.origin = { value: 'direct', label: 'Direct' };
        t.origin_id = generateString();
        t.emails = [];
        t.initializevilla = true;
        let vp = []; 
        const sortedVillas = sortByMonthAndPrice(propertiesCheck, t.checkin);
        

        sortedVillas.forEach((d) => { 
            const dr = { value: d.id, label: `${d?.nameHouse}` }
            vp.push(dr)
        })
        console.log(sortedVillas);
        t.villaPossible = vp;
        // return;
        setL(true);

        firebase.firestore().collection('demands').add(t).then((doc) => {
            console.log("Document successfully written!");
            toast.success("Demande créer avec succès");
            let sd = {
                statut: "Création depuis recherche",
                date: new Date(),
                data: JSON.stringify(t),
                uid: firebase.auth().currentUser.uid
            }
            firebase.firestore().collection(`demands/${doc.id}/logs`).add(sd)
            navigate(`/demand/edit/${doc.id}`);
            toast.success('Demande créée avec succès, redirection');
        }).catch((error) => {
            
            var errorMessage = error.message;
            toast.error(errorMessage);
        }).finally(() => {
            setL(false);
        })
    }


    const getUser = (uid) => {
        let d = ""
        users.forEach(u => {
            if (u.value === uid) {
                d = u.label
            }
        })
        return d
    }

    const getAllUser = async () => {
        await firebase.firestore()
            .collection("users")
            .get().then((snap) => {
                let s = [];
                snap.forEach((d) => {
                    var l = d.data();
                    if (l?.delete) {
                        // supprimer donc ne pas affiché
                    } else {
                        const dr = { value: d.id, label: `${l?.lastName} ${l?.firstName}`, data: l }
                        s.push(dr)
                    }
                    setUsers(s);

                    getUserL(firebase.auth().currentUser.uid, s, (user) => {
                        // console.log("user", user); 
                        if (user && user?.type === 'admin') {
                            setAdmin(true);
                        }
                    });
                })
            })
            .catch((error) => {
                console.log("error", error);
            });
    };


    const columns = [
        {
            accessor: 'Utilisateur',
            Header: 'uid',
            Cell: ({ row }) => (
                <>
                    <span>{getUser(row.original.uid)}</span>
                </>
            )
        },
        {
            accessor: '_create_At',
            Header: 'Date',
            headerProps: { className: 'text-900' },
            Cell: ({ row }) => (
                <>{row?.original?._create_At && row?.original?._create_At?.toDate !== undefined && (
                    <small className="has-text-grey is-abbr-like">
                        {useFormatDate(row.original?._create_At?.toDate(), {
                            day: 'numeric',
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                        })}
                    </small>
                )}
                </>
            )
        },
        {
            accessor: 'search',
            Header: 'Recherche',
            Cell: ({ row }) => (
                <>
                    <pre>{row?.original?.search && JSON.stringify(JSON.parse(row?.original?.search), null, 2)}</pre>

                </>
            )
        },
        // {
        //     accessor: 'result',
        //     Header : 'Résultat',
        //     Cell : ({row}) => (
        //         <>
        //             <pre>{row?.original?.result && JSON.stringify(JSON.parse(row?.original?.result), null, 2)}</pre>

        //         </> 
        //     )
        // },
        {
            accessor: 'action',
            Header: 'Voir les résultats',
            headerProps: { className: 'text-900' },
            Cell: rowData => {
                const { result, search } = rowData.row.original
                return (<>
                    <IconButton onClick={() => {
                        let d = JSON.parse(search)
                        setFrom(d);

                        setValueType(d?.type || null)

                        setData(JSON.parse(result));
                    }}
                        variant="falcon-default"
                        size="sm"
                        icon="eye"
                        transform="shrink-3"
                        className='me-2'
                    >
                        <span className="d-none d-sm-inline-block ms-1"></span>
                    </IconButton>


                </>
                )
            }
        }
    ]

    function LogTable() {
        if (l) {
            return <p>Chargement...</p>
        }

        return (<AdvanceTableWrapper
            columns={columns}
            data={searchs}
            sortable
            pagination
            perPage={205}>
            <AdvanceTable
                table
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                    bordered: true,
                    striped: true,
                    className: 'fs--1 mb-0 overflow-hidden'
                }}
            />
            <div className="mt-3">
                <AdvanceTableFooter
                    rowCount={searchs.length}
                    table
                    rowInfo
                    navButtons
                    rowsPerPageSelection
                />
            </div>
        </AdvanceTableWrapper>)
    }

 

    const BlocRes = ({ e, isadmin  }) => {
        const isInitiallyChecked = propertiesCheck?.some(pc => pc.id === e.id);
        const [check, setCheck] = useState(isInitiallyChecked);
    
        const handleCheckChange = (checked) => {
            setCheck(checked);
            const scrollY = window.scrollY; // Sauvegarde la position actuelle
            const updatedPropertiesCheck = checked
                ? [...propertiesCheck, e]
                : propertiesCheck.filter(pc => pc.id !== e.id);
    
            setPropertiesCheck(updatedPropertiesCheck);
            setTimeout(() => {
                window.scrollTo(0, scrollY); // Restaure la position après le re-render
            }, 0);
        };
    
        return (
            <div className="col-md-4 themed-grid-col mt-4">
                <div style={{ position: "relative" }}>
                    <img
                        src={e?.gallery?.length > 0 ? e?.gallery[0] : ""}
                        alt="pas d'image"
                        style={{
                            height: 200,
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: 20,
                            border: "1px solid orange",
                        }}
                    />
    
                    {isadmin && (
                        <input
                            style={{
                                position: "absolute",
                                top: 15,
                                right: 15,
                            }}
                            type="checkbox"
                            checked={check}
                            onChange={(event) => {handleCheckChange(event.target.checked)}}
                        />
                    )}
                </div>
                <div style={{ padding: 10 }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h5>{`${e?.nameHouse} - ${e?.type?.label}`}</h5>
                        <a target="_blank" rel="noopener noreferrer" href={isadmin ? `/villa/edit/${e.id}` : `/vl/${e.id}`}>
                            {isadmin ? 'détail': 'voir'}
                        </a>
                    </div>
                    <p style={{ fontSize: 11 }}>
                        {e?.description?.substring(0, 100)}...
                        <br />
                        <span style={{ fontSize: 14 }}>{e?.nbRooms} lits</span>
                        <br />
                        <span style={{ fontSize: 14 }}>{e?.maxGuest} invités</span>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <>
            <FalconComponentCard>
                <FalconComponentCard.Header title="Nouvelle recherche" light={false} noPreview={true} />
                <FalconComponentCard.Body >
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Form.Group as={Col} md="4" controlId="destinate">
                                <Form.Label>Destination (Nom, zipcode, quartier, ville, ..</Form.Label>
                                <Form.Control
                                    onChange={handleChange}
                                    name="destinate"
                                    type="text"
                                    placeholder="Destination"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Veuillez indiquez votre Destination.
                                </Form.Control.Feedback>
                                <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="4" controlId="checkin">
                                <Form.Label>Arrivée</Form.Label>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={checkIn}
                                    minDate={new Date()}
                                    startDate={checkIn}
                                    endDate={checkOut}
                                    selectsStart
                                    onChange={newDate => {
                                        let d = formd;
                                        d['checkin'] = newDate;
                                        setFrom(d)
                                        setCheckIn(newDate)
                                    }}
                                    customInput={
                                        <CustomDateInput
                                            formControlProps={{
                                                placeholder: 'jj/mm/yyyy',
                                                //     ...register(`ScheduleStartDate${index}`)
                                            }}
                                        />
                                    }
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="3" controlId={`ScheduleEndDate`}>
                                <Form.Label>Départ</Form.Label>

                                <DatePicker
                                    selected={checkOut}
                                    minDate={checkIn}
                                    selectsEnd
                                    startDate={checkIn}
                                    endDate={checkOut}
                                    dateFormat="dd/MM/yyyy"
                                    onChange={newDate => {
                                        let d = formd;
                                        d['checkout'] = newDate;
                                        setFrom(d)
                                        setCheckOut(newDate)
                                    }}
                                    customInput={
                                        <CustomDateInput
                                            formControlProps={{
                                                placeholder: 'jj/mm/yyyy',
                                                //     ...register(`ScheduleStartDate${index}`)
                                            }}
                                        />
                                    }
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <p>
                                Voyageurs
                            </p>
                            <Form.Group as={Col} md="3" controlId="adultNbr">
                                <Form.Label>Nombre total d'adulte</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="adultNbr"
                                    onChange={handleChange}
                                    placeholder="Nombre total d'adulte"
                                    min={1}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="kidsNbr">
                                <Form.Label>Nombre total d'enfant</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="kidsNbr"
                                    onChange={handleChange}
                                    placeholder="Nombre total d'enfant"
                                    min={0}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="3" controlId="roomsNbr">
                                <Form.Label>Nombre min de chambre(s)</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="roomsNbr"
                                    value={formd.roomsNbr}
                                    onChange={handleChange}
                                    placeholder="Nombre total de chambre"
                                    min={0}
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="3" controlId="roomsNbr">
                                <Form.Label>Nombre max de chambre(s)</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="roomsNbrMax"
                                    value={formd.roomsNbrMax}
                                    onChange={handleChange}
                                    placeholder="Nombre max de chambre"
                                    min={0}
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">


                            <Form.Group as={Col} md="3" controlId="type">
                                <Form.Label>Type de bien</Form.Label>
                                <Select
                                    options={typehomem}
                                    placeholder='Choisir...'
                                    classNamePrefix="react-select"
                                    value={valueType}
                                    onChange={value => {
                                        setValueType(value)
                                        let d = formd;
                                        d['type'] = value;
                                        setFrom(d);

                                    }}
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="3" controlId="priceMin">
                                <Form.Label>Budget Minimum (sans symbole €)</Form.Label>
                                <Form.Control
                                    onChange={handleChange}
                                    name="priceMin"
                                    type="text"
                                    placeholder="Prix minimum € "
                                />
                            </Form.Group>

                            <Form.Group as={Col} md="3" controlId="priceMax">
                                <Form.Label>Budget Maximum (sans symbole €)</Form.Label>
                                <Form.Control
                                    onChange={handleChange}
                                    name="priceMax"
                                    type="text"
                                    placeholder="Prix maximum €"
                                />
                            </Form.Group>
                        </Row>
                        <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Rechercher'}</Button>
                    </Form>
                    <Row>
                                <a href="#" onClick={() => {
                                    setCheckOut(null)
                                    setCheckIn(null)
                                    setValueType(null)
                                  setFrom({}) 
                                }}>Vider les champs</a>
                              </Row>
                </FalconComponentCard.Body>
            </FalconComponentCard>
            {data.length > 0 && (
                <>

                    <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
                        <p>Résultats ({data.length})</p>
                        <div>
                            {isadmin && (<>
                                <Button onClick={save} >{l ? 'Chargement' : 'Enregistrer la recherche'}</Button>
                                <Button style={{ marginLeft: 20 }} onClick={demand}>{l ? 'Chargement' : 'Transformer en demande'}</Button>
                            </>)}

                        </div>
                    </div>
                    <div class="container">
                        <div class="row mb-3">
                            {data?.map(e => (
                                <BlocRes
                                    key={e.id}
                                    e={e}
                                    isadmin={isadmin} 
                                    // propertiesCheck={propertiesCheck}
                                    // setPropertiesCheck={setPropertiesCheck}
                                />
                            ) 
                            )}
                        </div>
                    </div>
                </>
            )}


            {isadmin && searchs.length > 0 && (
                <FalconComponentCard>
                    <FalconComponentCard.Header title={'Logs de recherche'} light={false} noPreview={true} />
                    <FalconComponentCard.Body>
                        <LogTable />
                    </FalconComponentCard.Body>
                </FalconComponentCard>
            )}
        </>
    );
};

export default Search;
